import AsyncStorage from "@react-native-async-storage/async-storage";

/**
 * Utility function to get the appropriate user ID.
 * @returns {Promise<string | null>} - The resolved userIdToUse.
 */
export const getUserIdToUse = async (): Promise<string | null> => {
  try {
    const storedUserId = await AsyncStorage.getItem("userId");
    console.log("Stored User ID:", storedUserId);
    const emulatedUser = await AsyncStorage.getItem("emulatedUser");

    if (emulatedUser) {
      const parsedEmulatedUser = JSON.parse(emulatedUser);
      return parsedEmulatedUser.id;
    } else {
      return storedUserId ? storedUserId : null;
    }
  } catch (error) {
    console.error("Error retrieving user ID:", error);
    return null;
  }
};
